module.exports = __webpack_public_path__ + "images/home-dingtalk-work/howto_1-2e7ade38c936226a12a1f9d7360f5b3c.png";